import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';

export class ListUnstyled extends Mixin {
  style() {
    return css`
      padding-left: 0;
      list-style: none;
    `;
  }
}
